module.exports = __webpack_public_path__ + "img/yonhy-lescano.576d58f2.png";